import React from "react";
import "./OrdersPage.css";
import { FaPlus } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

export default function OrdersPage() {
  const navigate = useNavigate();
  return (
    <section className="ordersPage">
      <h1>Orders Details</h1>
      <hr />

      <div className="tableWrapper">
        <table className="ordersTable">
          <thead>
            <tr>
              <th>User Name</th>
              <th>Name</th>
              <th>Image</th>
              <th>Category</th>
              <th>Quantity</th>
              <th>Price</th>
              <th>Delivery Date</th>
              <th>Total Price</th>
            </tr>
          </thead>

          <tbody></tbody>
        </table>
      </div>

      <div className="add-product">
        <FaPlus
          className="plus"
          onClick={() => {
            navigate("/admin/products/add");
          }}
        />
      </div>
    </section>
  );
}
